import React, { Fragment } from 'react';
import { Card } from '../../../components/ui/Card';
import { TabNavigation } from '../../../components/operations/TabNavigation';
import { OperationsSwitcher } from '../../../components/operations/OperationsSwitcher';
import { TrendingUp, TrendingDown, Star, AlertTriangle, ChevronDown, ChevronRight } from 'lucide-react';
const TEAM_TABS = [{
  label: 'Shift Planner',
  path: ''
}, {
  label: 'Leave Timeline',
  path: 'leave'
}, {
  label: 'Team Directory',
  path: 'directory'
}, {
  label: 'Performance',
  path: 'performance'
}, {
  label: 'Costs',
  path: 'costs'
}];
const PERFORMANCE_DATA = [{
  name: 'Marko S.',
  hours: '42h',
  orders: 287,
  output: 6.8,
  prep: '7.2 min',
  rating: 9.4,
  expanded: true
}, {
  name: 'Ana P.',
  hours: '38h',
  orders: 243,
  output: 6.4,
  prep: '6.9 min',
  rating: 9.5,
  top: true
}, {
  name: 'Stefan M.',
  hours: '40h',
  orders: 312,
  output: 7.8,
  prep: '6.5 min',
  rating: 9.6
}, {
  name: 'Nuran',
  hours: '36h',
  orders: 198,
  output: 5.5,
  prep: '8.8 min',
  rating: 9.1,
  warning: true
}];
const LEADERBOARD = [{
  station: '🍔 BURGERI',
  items: [{
    name: 'Stefan M.',
    score: '7.8/hr'
  }, {
    name: 'Marko S.',
    score: '7.0/hr'
  }, {
    name: 'Vihanga M.',
    score: '6.4/hr'
  }]
}, {
  station: '🥞 PALAČINKE',
  items: [{
    name: 'Ana P.',
    score: '7.2/hr'
  }, {
    name: 'Marko S.',
    score: '6.5/hr'
  }, {
    name: 'Hansamali',
    score: '6.1/hr'
  }]
}, {
  station: '📦 PAKOVANJE',
  items: [{
    name: 'Marko S.',
    score: '8.2/hr'
  }, {
    name: 'Shehan T.',
    score: '7.9/hr'
  }, {
    name: 'Ana P.',
    score: '7.5/hr'
  }]
}];
export function Performance() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2252">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-2253">Team Performance</h1>

      <OperationsSwitcher data-id="element-2254" />

      <TabNavigation tabs={TEAM_TABS} basePath="/operations/team" data-id="element-2255" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2256">
        {/* Main Table */}
        <Card className="lg:col-span-2" noPadding data-id="element-2257">
          <div className="p-4 border-b border-white/10 font-bold" data-id="element-2258">
            Individual Output Metrics
          </div>
          <div className="overflow-x-auto" data-id="element-2259">
            <table className="w-full text-sm" data-id="element-2260">
              <thead data-id="element-2261">
                <tr className="text-text-secondary border-b border-white/5" data-id="element-2262">
                  <th className="w-8 p-4" data-id="element-2263"></th>
                  <th className="text-left p-4" data-id="element-2264">EMPLOYEE</th>
                  <th className="text-center p-4" data-id="element-2265">HOURS</th>
                  <th className="text-center p-4" data-id="element-2266">ORDERS</th>
                  <th className="text-center p-4" data-id="element-2267">OUTPUT/HR</th>
                  <th className="text-center p-4" data-id="element-2268">AVG PREP</th>
                  <th className="text-center p-4" data-id="element-2269">RATING</th>
                </tr>
              </thead>
              <tbody data-id="element-2270">
                {PERFORMANCE_DATA.map((row, i) => <Fragment key={i} data-id="element-2271">
                    <tr className={`border-b border-white/5 hover:bg-white/5 ${row.expanded ? 'bg-white/5' : ''}`} data-id="element-2272">
                      <td className="p-4 text-center" data-id="element-2273">
                        {row.expanded ? <ChevronDown size={16} data-id="element-2274" /> : <ChevronRight size={16} data-id="element-2275" />}
                      </td>
                      <td className="p-4 font-medium flex items-center gap-2" data-id="element-2276">
                        {row.name}
                        {row.top && <span className="text-xs bg-accent-success/20 text-accent-success px-1.5 py-0.5 rounded" data-id="element-2277">
                            Top
                          </span>}
                        {row.warning && <span className="text-xs bg-accent-warning/20 text-accent-warning px-1.5 py-0.5 rounded" data-id="element-2278">
                            Low
                          </span>}
                      </td>
                      <td className="p-4 text-center" data-id="element-2279">{row.hours}</td>
                      <td className="p-4 text-center" data-id="element-2280">{row.orders}</td>
                      <td className="p-4 text-center font-bold" data-id="element-2281">
                        {row.output}
                      </td>
                      <td className="p-4 text-center" data-id="element-2282">{row.prep}</td>
                      <td className="p-4 text-center font-bold text-accent-success" data-id="element-2283">
                        {row.rating}
                      </td>
                    </tr>
                    {row.expanded && <tr className="bg-background-elevated/30" data-id="element-2284">
                        <td colSpan={7} className="p-4" data-id="element-2285">
                          <div className="bg-background-card rounded-lg border border-white/5 p-4 ml-8" data-id="element-2286">
                            <div className="grid grid-cols-6 gap-4 text-xs text-text-secondary mb-2 uppercase font-medium" data-id="element-2287">
                              <div className="col-span-2" data-id="element-2288">Station</div>
                              <div className="text-center" data-id="element-2289">Hours</div>
                              <div className="text-center" data-id="element-2290">Orders</div>
                              <div className="text-center" data-id="element-2291">Output/hr</div>
                              <div className="text-center" data-id="element-2292">Rating</div>
                            </div>
                            <div className="grid grid-cols-6 gap-4 text-sm items-center py-2 border-b border-white/5" data-id="element-2293">
                              <div className="col-span-2 font-medium flex items-center gap-2" data-id="element-2294">
                                🍔 Burgeri
                              </div>
                              <div className="text-center" data-id="element-2295">28h</div>
                              <div className="text-center" data-id="element-2296">196</div>
                              <div className="text-center" data-id="element-2297">7.0/hr</div>
                              <div className="text-center text-accent-success" data-id="element-2298">
                                9.3
                              </div>
                            </div>
                            <div className="grid grid-cols-6 gap-4 text-sm items-center py-2" data-id="element-2299">
                              <div className="col-span-2 font-medium flex items-center gap-2" data-id="element-2300">
                                🥞 Palačinke
                              </div>
                              <div className="text-center" data-id="element-2301">14h</div>
                              <div className="text-center" data-id="element-2302">91</div>
                              <div className="text-center" data-id="element-2303">6.5/hr</div>
                              <div className="text-center text-accent-success" data-id="element-2304">
                                9.6
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>}
                  </Fragment>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Sidebar Widgets */}
        <div className="space-y-6" data-id="element-2305">
          {/* Trends */}
          <Card data-id="element-2306">
            <h3 className="font-bold mb-4" data-id="element-2307">Trends</h3>
            <div className="space-y-4" data-id="element-2308">
              <div className="flex items-start gap-3" data-id="element-2309">
                <div className="p-1.5 bg-accent-success/10 rounded text-accent-success mt-0.5" data-id="element-2310">
                  <TrendingUp size={16} data-id="element-2311" />
                </div>
                <div className="text-sm" data-id="element-2312">
                  <span className="font-bold" data-id="element-2313">Stefan M.</span> improved 12% vs
                  last week
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-2314">
                <div className="p-1.5 bg-accent-error/10 rounded text-accent-error mt-0.5" data-id="element-2315">
                  <TrendingDown size={16} data-id="element-2316" />
                </div>
                <div className="text-sm" data-id="element-2317">
                  <span className="font-bold" data-id="element-2318">Nuran</span> prep time increased —
                  possible training needed
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-2319">
                <div className="p-1.5 bg-accent-warning/10 rounded text-accent-warning mt-0.5" data-id="element-2320">
                  <Star size={16} data-id="element-2321" />
                </div>
                <div className="text-sm" data-id="element-2322">
                  <span className="font-bold" data-id="element-2323">Ana P.</span> highest rating for
                  3rd consecutive week
                </div>
              </div>
            </div>
          </Card>

          {/* Leaderboard */}
          <Card data-id="element-2324">
            <h3 className="font-bold mb-4" data-id="element-2325">Station Leaderboard</h3>
            <div className="space-y-6" data-id="element-2326">
              {LEADERBOARD.map(cat => <div key={cat.station} data-id="element-2327">
                  <div className="text-xs font-bold text-text-secondary uppercase mb-2" data-id="element-2328">
                    {cat.station}
                  </div>
                  <div className="space-y-2" data-id="element-2329">
                    {cat.items.map((item, i) => <div key={i} className="flex justify-between text-sm" data-id="element-2330">
                        <div className="flex items-center gap-2" data-id="element-2331">
                          <span className={`w-4 text-center font-bold ${i === 0 ? 'text-accent-warning' : 'text-text-muted'}`} data-id="element-2332">
                            {i + 1}.
                          </span>
                          <span data-id="element-2333">{item.name}</span>
                        </div>
                        <span className="font-mono text-text-secondary" data-id="element-2334">
                          {item.score}
                        </span>
                      </div>)}
                  </div>
                </div>)}
            </div>
          </Card>
        </div>
      </div>
    </div>;
}